import { Swiper } from 'swiper';
import 'swiper/css';

export default function textItems() {
    if (document.querySelector('.text-items__container')) {
        initSwiper();
    }

    document.querySelectorAll('.text-items__video').forEach(initVideoPlayer);
}

const initSwiper = () => {
    return new Swiper('.text-items__container', {
        slidesPerView: 1.2,
        spaceBetween: 16,
        enabled: true,
        breakpoints: {
            500: {
                enabled: true,
                slidesPerView: 2.2,
                spaceBetween: 16,
            },
            768: {
                enabled: true,
                slidesPerView: 3.2,
                spaceBetween: 16,
            },
            1024: {
                enabled: false,
                slidesPerView: 4,
                spaceBetween: 16,
            },
        },
    });
};

const initVideoPlayer = (el) => {
    const videoId = el.dataset.videoId;
    if (!videoId) return;

    const poster = el.querySelector('.text-items__video-poster');
    const playerWrap = el.querySelector('.text-items__video-player');
    const iframe = el.querySelector('.text-items__video-player iframe');

    if (!poster || !playerWrap || !iframe) return;

    poster.addEventListener('click', () => {
        iframe.src = `https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0`;
        poster.style.display = 'none';
        playerWrap.style.display = 'block';
    });
};
